import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Navigation } from "@/components/sections/Navigation";
import { Hero } from "@/components/sections/Hero";
import { WhatWeDo } from "@/components/sections/WhatWeDo";
import { WhyDifferent } from "@/components/sections/WhyDifferent";
import { OurProcess } from "@/components/sections/OurProcess";
import { WhoWeWorkWith } from "@/components/sections/WhoWeWorkWith";
import { GetStarted } from "@/components/sections/GetStarted";
import CallPage from "@/components/sections/CallPage";
import BendPage from "@/components/sections/bend/BendPage";
import AIPage from "@/components/sections/ai/AIPage";

function HomePage() {
  return (
    <div className="bg-white min-h-screen">
      <Navigation />
      <main>
        <Hero />
        <WhatWeDo />
        <WhoWeWorkWith />
        <WhyDifferent />
        <OurProcess />
        <GetStarted />
      </main>
      <footer
        data-testid="footer"
        className="bg-[#0F172A] border-t border-[#1E293B]"
      >
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-20 py-12 md:py-16">
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
            <div>
              <span className="font-['Playfair_Display'] font-semibold text-2xl text-white">
                BLD
              </span>
              <p className="mt-2 text-[14px] text-[#475569]">
                Media buying and funnel building. That's it.
              </p>
            </div>
            <div className="flex flex-wrap gap-6 text-[14px] text-[#475569]">
              {[
                ["Services", "#what-we-do"],
                ["Process", "#process"],
                ["Clients", "#who-we-work-with"],
                ["Contact", "mailto:marketing@bldventuresgroup.com"],
              ].map(([label, href]) => (
                <a
                  key={label}
                  href={href}
                  onClick={href.startsWith("#") ? (e) => {
                    e.preventDefault();
                    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
                  } : undefined}
                  className="hover:text-white transition-colors"
                >
                  {label}
                </a>
              ))}
            </div>
          </div>
          <div className="mt-10 pt-8 border-t border-[#1E293B] flex flex-col sm:flex-row items-center justify-between gap-4 text-[13px] text-[#334155]">
            <p>BLD Marketing. All rights reserved.</p>
            <p>Two operators. Zero overhead.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/call" element={<CallPage />} />
        <Route path="/bend" element={<BendPage />} />
        <Route path="/ai" element={<AIPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
